
import classes from '../api/classes'
import moment from 'moment'

export const state = {
  classes: [],
  class_pagination_data: {},
  class: '',
  events: []
}

export const getters = {
  classes: state => state.classes,
  class_pagination_data: state => state.class_pagination_data,
  class: state => state.class,
  events (state) {
    return state.events.map(function (item) {
      return {
        start: moment(item.date + ' ' + item.start_time).format(),
        end: moment(item.date + ' ' + item.end_time).format(),
        title: item.first_student,
        class_detail: item
      }
    })
  }
}

export const mutations = {
  ADD_CLASS (state, data) {
    state.classes.push(data)
  },
  CLONE_CLASS (state, data) {
    state.classes.push(data)
  },
  SET_CLASSES (state, data) {
    state.classes = data
  },
  SET_CLASSES_CALENDAR (state, data) {
    state.events = data
  },
  SET_CLASS_PAGINATION (state, data) {
    state.class_pagination_data = data
  },
  SHOW_CLASS (state, data) {
    state.class = data
  }
}

export const actions = {
  GET_CLASSES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classes.get(data).then(response => {
        commit('SET_CLASSES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_CLASS_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_CLASSES_CALENDAR ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classes.getClassesCalendar(data).then(response => {
        commit('SET_CLASSES_CALENDAR', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_CLASS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classes.create(data).then(response => {
        commit('ADD_CLASS', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  CLONE_CLASS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classes.clone(data).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_CLASS ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      classes.show(id).then(response => {
        commit('SHOW_CLASS', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_CLASS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      classes.update(data, state.class.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_CLASS ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      classes.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/classes.js